import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, ClockIcon } from 'lucide-react';
import { ArrowButton } from '../components/ui/ArrowButton';
import type { NavGroup, NavLink } from '../types/navigation';
type ComingSoonProps = {
  page: NavLink;
  group?: NavGroup;
};
export function ComingSoon({
  page,
  group
}: ComingSoonProps) {
  const siblings = group ? group.links.filter(l => l.path !== page.path) : [];
  return <section className="w-full bg-white" data-id="element-246" data-mp="d9fjfrxikrq5">
      <div className="mx-auto max-w-[1320px] px-6 pb-24 pt-10" data-id="element-247" data-mp="9a6o4imtslsh">
        <nav aria-label="Fil d’Ariane" className="flex flex-wrap items-center gap-1.5 text-[13px] text-ink-muted" data-id="element-248" data-mp="97kgkizxq6a9">
          <Link to="/" className="hover:text-ink" data-id="element-249" data-mp="i1yscbl9ayom">
            Accueil
          </Link>
          {group && group.path !== page.path && <>
              <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-250" data-mp="wzr731izbj1r" />
              <Link to={group.path} className="hover:text-ink" data-id="element-251" data-mp="s17kcywka38c">
                {group.label}
              </Link>
            </>}
          <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-252" data-mp="x82zzwdqtd8r" />
          <span className="text-ink" aria-current="page" data-id="element-253" data-mp="125w66pf1q791">
            {page.label}
          </span>
        </nav>

        <div className="mt-12 grid gap-12 lg:grid-cols-12" data-id="element-254" data-mp="165davgmnf0d5">
          <div className="lg:col-span-7" data-id="element-255" data-mp="1b61bmu0oivkk">
            <h1 className="font-display text-[60px] text-ink md:text-[96px]" data-id="element-256" data-mp="1b72p15563u5g">{page.label}</h1>
            {page.description && <p className="mt-5 max-w-lg text-[18px] leading-relaxed text-ink-muted" data-id="element-257" data-mp="1l3ywd7jbya8f">{page.description}</p>}
            <div className="mt-10 flex max-w-lg items-start gap-4 rounded-2xl border border-dashed border-ink/20 bg-canvas p-6" data-id="element-258" data-mp="1pufcizejc9yh">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-ink text-leaf" data-id="element-259" data-mp="1tvr59dsphbaw">
                <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-260" data-mp="1yx6od0bbp7qn" />
              </span>
              <div data-id="element-261" data-mp="23uyfhs458pts">
                <p className="text-[16px] font-semibold text-ink" data-id="element-262" data-mp="23sc7xsh96abk">Page en cours de conception</p>
                <p className="mt-1 text-[15px] leading-relaxed text-ink-muted" data-id="element-263" data-mp="3q4gig20e1ui">
                  Le contenu de cette page sera complété après la validation de la page d’accueil.
                </p>
              </div>
            </div>
            <ArrowButton to="/" className="mt-8" data-id="element-264" data-mp="8qs4styus4l1">
              Retour à l’accueil
            </ArrowButton>
          </div>

          {siblings.length > 0 && group && <aside className="lg:col-span-4 lg:col-start-9" data-id="element-265" data-mp="mkjfi5obluic">
              <p className="text-[14px] font-semibold text-ink" data-id="element-266" data-mp="igbq06a1gaj2">Dans {group.label}</p>
              <ul className="mt-4 border-t border-line" data-id="element-267" data-mp="wfthwuims3wn">
                {siblings.map(s => <li key={s.path} className="border-b border-line" data-id="element-268" data-mp="ritbgihvcz50">
                    <Link to={s.path} className="group flex items-center justify-between py-4" data-id="element-269" data-mp="2y7zgpjygl6tf">
                      <span className="text-[15px] text-ink group-hover:text-brand" data-id="element-270" data-mp="2t9eifq2rox7m">{s.label}</span>
                      <ChevronRightIcon className="h-4 w-4 text-ink/30 group-hover:text-brand" aria-hidden="true" data-id="element-271" data-mp="18rdsrv1izwgd" />
                    </Link>
                  </li>)}
              </ul>
            </aside>}
        </div>
      </div>
    </section>;
}